<template>
  <div>
    <v-row>
      <v-col cols="12" md="12" class="mb-3 py-0">
        <v-switch
          v-model="myEodHistorical.active"
          :disabled="loading"
          hide-details
          class="mt-2 py-0"
        >
          <template v-slot:label>
            <span class="mr-2">
              {{ $t(`views.stocks.stockModal.customMarket.eodHistorical.switch`) }}
            </span>
            <InfoIcon :text="$t(`views.stocks.stockModal.customMarket.eodHistorical.info`)" />
          </template>
        </v-switch>
      </v-col>
      <v-col v-if="myEodHistorical.active" cols="12" md="12" class="mt-1 mb-4 py-0">
        <div>
          <a class="position-form-link" @click="!loading && addNewHistorical()">
            <v-icon color="primary">
              mdi-plus
            </v-icon>
            {{ $t('views.stocks.stockModal.customMarket.eodHistorical.addNewPrice') }}
          </a>
        </div>

        <div
          v-for="(month, idx) in myEodHistorical.historical"
          :key="idx"
          class="d-flex align-end mt-4 mb-4"
        >
          <div>
            <v-menu
              :ref="`menu-${idx}`"
              v-model="month.menu"
              transition="scale-transition"
              min-width="290px"
              content-class="elevation-1"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="month.month"
                  :label="$t('views.stocks.stockModal.customMarket.eodHistorical.month')"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  :disabled="loading"
                  hide-details
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="month.month"
                type="month"
                no-title
                scrollable
                :show-current="false"
                :disabled="loading"
                @input="month.menu = false"
              />
            </v-menu>
          </div>

          <div class="mx-5">
            <CurrencyInput
              v-model="month.close"
              :currency="myPosition.currency"
              :label="$t('views.stocks.stockModal.customMarket.eodHistorical.close')"
              :disabled="loading"
            />
          </div>

          <div class="pb-1">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  class="mr-4 mb-0"
                  v-on="on"
                  @click="!loading && removeHistorical(idx)"
                >
                  mdi-delete-outline
                </v-icon>
              </template>
              <span>
                {{ $t('views.stocks.stockModal.customMarket.eodHistorical.deletePrice') }}
              </span>
            </v-tooltip>
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { DateTime } from 'luxon'
import CurrencyInput from '@/views/components/common/CurrencyInput'
import InfoIcon from '@/views/components/common/InfoIcon'
import { get } from 'lodash'

export default {
  components: { CurrencyInput, InfoIcon },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    myPosition: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    myEodHistorical: {},
    menu: false,
  }),
  watch: {
    value: {
      handler() {
        this.myEodHistorical = this.value
      },
      immediate: true,
    },
    myEodHistorical: {
      handler() {
        if (!this.myEodHistorical) return
        if (this.myEodHistorical === this.value) return

        this.$emit('input', this.myEodHistorical)
      },
      deep: true,
    },
  },
  methods: {
    addNewHistorical() {
      const monthDefault = DateTime.now().minus({ month: 1 }).toFormat('yyyy-MM')
      const closeDefault = get(this.myPosition, 'customMarket.eod.close', undefined)
      this.myEodHistorical.historical.unshift({ month: monthDefault, close: closeDefault })
    },
    removeHistorical(idx) {
      this.myEodHistorical.historical.splice(idx, 1)
    },
  },
}
</script>
